import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useTheme,
  Divider,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import styled from '@emotion/styled';

const StatusTag = styled(Box)<{ status: string }>(({ status }) => ({
  backgroundColor: '#F3F4F6',
  color: '#4B5563',
  padding: '2px 12px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: 600,
  display: 'inline-block',
  marginTop: '8px',
}));

interface ContactDetailModalProps {
  open: boolean;
  onClose: () => void;
  contact: any;
  children: React.ReactNode;
}

const ContactDetailModal: React.FC<ContactDetailModalProps> = ({
  open,
  onClose,
  contact,
  children,
}) => {
  const theme = useTheme();

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: 420,
          boxShadow: theme.shadows[10],
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: theme.palette.background.paper,
          flexShrink: 0,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700} sx={{ color: '#333' }}>
            Contact Details
          </Typography>
          <StatusTag status="Contact">
            Request ID: #{contact?.contact_id}
          </StatusTag>
        </Box>

        <IconButton onClick={onClose} size="medium" sx={{ color: theme.palette.action.active }}>
          <HighlightOffIcon fontSize="medium" />
        </IconButton>
      </Box>

      <Divider variant="fullWidth" />

      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          bgcolor: theme.palette.background.paper,
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default ContactDetailModal;
